// Data Biodata Lengkap Mahasiswa untuk halaman detail

export const biodataDropdown = {
    statusmhs: [
        { id_status_mahasiswa: 1, status_keterangan: "Aktif" },
        { id_status_mahasiswa: 2, status_keterangan: "Cuti" },
        { id_status_mahasiswa: 3, status_keterangan: "Lulus" },
        { id_status_mahasiswa: 4, status_keterangan: "Non-Aktif" },
        { id_status_mahasiswa: 5, status_keterangan: "DO" }
    ],
    statuskelas: [
        { id: 1, jenis_kelas: "Reguler" },
        { id: 2, jenis_kelas: "Karyawan" }
    ],
    jalur: [
        { id_jalur: 1, nama_jalur: "Reguler Pagi" },
        { id_jalur: 2, nama_jalur: "Reguler Sore" },
        { id_jalur: 3, nama_jalur: "Karyawan" }
    ],
    kategori_kelas: [
        { id_subjalur: 1, ket_subjalur: "Kelas A" },
        { id_subjalur: 2, ket_subjalur: "Kelas B" },
        { id_subjalur: 3, ket_subjalur: "Kelas C" }
    ],
    jalur_transfer: [
        { id_gruptransfer: 1, nama_gruptransfer: "Bukan Transfer" },
        { id_gruptransfer: 2, nama_gruptransfer: "Transfer Internal" },
        { id_gruptransfer: 3, nama_gruptransfer: "Transfer Eksternal" }
    ],
    konsentrasi: [
        { id: 1, nama_konsentrasi: "Web Development" },
        { id: 2, nama_konsentrasi: "Mobile Development" },
        { id: 3, nama_konsentrasi: "Data Science" },
        { id: 4, nama_konsentrasi: "Network Security" }
    ],
    agama: ["Islam", "Kristen", "Katolik", "Hindu", "Buddha", "Konghucu"],
    status_nikah: ["Belum Menikah", "Menikah", "Cerai"],
    jenis_tinggal: ["Bersama Orang Tua", "Kost", "Kontrak", "Asrama"],
    transportasi: ["Jalan Kaki", "Sepeda", "Motor", "Mobil", "Angkutan Umum"],
    pendidikan: ["SD", "SMP", "SMA", "D1", "D2", "D3", "S1", "S2"],
    pekerjaan: ["PNS", "TNI/Polri", "Pegawai Swasta", "Wiraswasta", "Petani", "Buruh", "Tidak Bekerja"],
    penghasilan: [
        "< Rp. 1.000.000",
        "Rp. 1.000.000 - Rp. 2.000.000",
        "Rp. 2.000.000 - Rp. 5.000.000",
        "Rp. 5.000.000 - Rp. 10.000.000",
        "> Rp. 10.000.000"
    ],
    jurusan: [
        { nama_jurusan: "Teknik Informatika" },
        { nama_jurusan: "Sistem Informasi" },
        { nama_jurusan: "Teknik Mesin" },
        { nama_jurusan: "Teknik Elektro" },
        { nama_jurusan: "Manajemen" },
        { nama_jurusan: "Akuntansi" }
    ],
    jenjangpendidikan_asal: [
        { value: "D1", nama: "Diploma 1" },
        { value: "D2", nama: "Diploma 2" },
        { value: "D3", nama: "Diploma 3" },
        { value: "S1", nama: "Sarjana" }
    ],
    provinsi: [
        { i: 1, pname: "Jawa Timur" },
        { i: 2, pname: "Jawa Tengah" },
        { i: 3, pname: "Jawa Barat" },
        { i: 4, pname: "DKI Jakarta" },
        { i: 5, pname: "Bali" }
    ],
    kota: {
        1: [ // Jawa Timur
            { ic: 1, cname: "Kota Malang" },
            { ic: 2, cname: "Kabupaten Malang" },
            { ic: 3, cname: "Kota Surabaya" },
            { ic: 4, cname: "Kota Kediri" },
            { ic: 5, cname: "Kota Blitar" }
        ],
        2: [ // Jawa Tengah
            { ic: 6, cname: "Kota Semarang" },
            { ic: 7, cname: "Kota Solo" }
        ]
    },
    kecamatan: {
        1: [ // Kota Malang
            { dname: "Klojen" },
            { dname: "Lowokwaru" },
            { dname: "Blimbing" },
            { dname: "Kedungkandang" },
            { dname: "Sukun" }
        ],
        2: [ // Kabupaten Malang
            { dname: "Singosari" },
            { dname: "Lawang" },
            { dname: "Pakis" }
        ]
    }
};

// Data biodata lengkap per mahasiswa
export const biodataMahasiswa = {
    "20201001": {
        nim: "20201001",
        nama: "Andi Pratama",
        prodi: "Teknik Informatika",
        dosen_wali: "Dr. Citra Dewi, S.Kom., M.Cs.",
        foto_mhs: "0",
        status_mhs: 1,
        koderpl: "Non RPL",
        jalur: "1",
        kategori_kelas: "1",
        jalur_transfer: "1",
        tgl_masuk: "2020-09-01",
        tgl_lulus: "",
        tgl_cetaktranskrip: "",
        judul_skripsi: "",
        konsentrasi: "1",
        noijazah: "",
        nina: "",
        gender: "1",
        tempat_lahir: "Malang",
        tgl_lahir: "2002-05-15",
        kewarganegaraan: "WNI",
        agama: "Islam",
        status_nikah: "Belum Menikah",
        provinsi: "1",
        kab: "Kota Malang",
        jalan: "Jl. Merdeka No. 123",
        dusun: "Merdeka",
        kecamatan: "Klojen",
        kelurahan: "Kauman",
        rt: "001",
        rw: "002",
        kdpos: "65112",
        nowa: "081234567890",
        email: "andi.pratama@student.asia.ac.id",
        nik: "3573051505020001",
        nisn: "0012345678",
        npwp: "",
        jenis_tinggal: "Bersama Orang Tua",
        alat_transport: "Motor",
        kodeva: "1234567890",
        nikayah: "3573050101700001",
        namaayah: "Budi Pratama",
        keterangan_hidup_ayah: "Hidup",
        tgl_lahir_ayah: "1970-01-01",
        pendidikan_ayah: "S1",
        pekerjaan_ayah: "PNS",
        penghasilan_ayah: "Rp. 5.000.000 - Rp. 10.000.000",
        notelp_ayah: "081234567001",
        nik_ibu: "3573050202750002",
        nama_ibu: "Siti Aminah",
        keterangan_hidup_ibu: "Hidup",
        tgl_lahir_ibu: "1975-02-02",
        pendidikan_ibu: "SMA",
        pekerjaan_ibu: "Tidak Bekerja",
        penghasilan_ibu: "< Rp. 1.000.000",
        notelp_ibu: "081234567002",
        nama_wali: "",
        tgllahirwali: "",
        pendidikan_wali: "",
        pekerjaan_wali: "",
        penghasilan_wali: "",
        notelpwali: "",
        kebutuhan_khusus_mhs: [],
        kebutuhan_khusus_ayah: [],
        kebutuhan_khusus_ibu: [],
        nim_asal_tf: "",
        thnlulus_tf: "",
        jenjang_asal_tf: "",
        perguruan_tinggi_tf: "",
        jurusan_asal_tf: "",
        nama_perguruan_tinggi_asal: "",
        berkas: {
            ktp: "20201001-ktp.jpg",
            kk: "20201001-kk.jpg",
            ijazah: "20201001-ijazah.pdf",
            ijazah_transfer: "",
            transkrip: "",
            skp: ""
        }
    },
    "20201002": {
        nim: "20201002",
        nama: "Bella Safitri",
        prodi: "Teknik Informatika",
        dosen_wali: "Dr. Citra Dewi, S.Kom., M.Cs.",
        foto_mhs: "0",
        status_mhs: 1,
        koderpl: "Non RPL",
        jalur: "1",
        kategori_kelas: "1",
        jalur_transfer: "1",
        tgl_masuk: "2020-09-01",
        tgl_lulus: "",
        tgl_cetaktranskrip: "",
        judul_skripsi: "",
        konsentrasi: "3",
        noijazah: "",
        nina: "",
        gender: "2",
        tempat_lahir: "Surabaya",
        tgl_lahir: "2002-08-20",
        kewarganegaraan: "WNI",
        agama: "Kristen",
        status_nikah: "Belum Menikah",
        provinsi: "1",
        kab: "Kota Malang",
        jalan: "Jl. Sudirman No. 45",
        dusun: "Sudirman",
        kecamatan: "Lowokwaru",
        kelurahan: "Dinoyo",
        rt: "003",
        rw: "004",
        kdpos: "65145",
        nowa: "081234567891",
        email: "bella.safitri@student.asia.ac.id",
        nik: "3573052008020002",
        nisn: "0012345679",
        npwp: "",
        jenis_tinggal: "Kost",
        alat_transport: "Motor",
        kodeva: "1234567891",
        nikayah: "3578010101680001",
        namaayah: "Herman Safitri",
        keterangan_hidup_ayah: "Hidup",
        tgl_lahir_ayah: "1968-01-01",
        pendidikan_ayah: "S2",
        pekerjaan_ayah: "Pegawai Swasta",
        penghasilan_ayah: "> Rp. 10.000.000",
        notelp_ayah: "081234567101",
        nik_ibu: "3578010202720002",
        nama_ibu: "Maria Safitri",
        keterangan_hidup_ibu: "Hidup",
        tgl_lahir_ibu: "1972-02-02",
        pendidikan_ibu: "S1",
        pekerjaan_ibu: "Pegawai Swasta",
        penghasilan_ibu: "Rp. 5.000.000 - Rp. 10.000.000",
        notelp_ibu: "081234567102",
        nama_wali: "",
        tgllahirwali: "",
        pendidikan_wali: "",
        pekerjaan_wali: "",
        penghasilan_wali: "",
        notelpwali: "",
        kebutuhan_khusus_mhs: [],
        kebutuhan_khusus_ayah: [],
        kebutuhan_khusus_ibu: [],
        nim_asal_tf: "",
        thnlulus_tf: "",
        jenjang_asal_tf: "",
        perguruan_tinggi_tf: "",
        jurusan_asal_tf: "",
        nama_perguruan_tinggi_asal: "",
        berkas: {
            ktp: "20201002-ktp.jpg",
            kk: "20201002-kk.jpg",
            ijazah: "20201002-ijazah.pdf",
            ijazah_transfer: "",
            transkrip: "",
            skp: ""
        }
    },
    "20201003": {
        nim: "20201003",
        nama: "Cahyo Nugroho",
        prodi: "Teknik Informatika",
        dosen_wali: "Ir. Dedi Hartono, M.Kom.",
        foto_mhs: "0",
        status_mhs: 1,
        koderpl: "Non RPL",
        jalur: "1",
        kategori_kelas: "2",
        jalur_transfer: "1",
        tgl_masuk: "2020-09-01",
        tgl_lulus: "",
        tgl_cetaktranskrip: "",
        judul_skripsi: "",
        konsentrasi: "4",
        noijazah: "",
        nina: "",
        gender: "1",
        tempat_lahir: "Jakarta",
        tgl_lahir: "2001-12-10",
        kewarganegaraan: "WNI",
        agama: "Islam",
        status_nikah: "Belum Menikah",
        provinsi: "1",
        kab: "Kota Malang",
        jalan: "Jl. Diponegoro No. 67",
        dusun: "Diponegoro",
        kecamatan: "Blimbing",
        kelurahan: "Purwantoro",
        rt: "005",
        rw: "006",
        kdpos: "65125",
        nowa: "081234567892",
        email: "cahyo.nugroho@student.asia.ac.id",
        nik: "3573051012010003",
        nisn: "0012345680",
        npwp: "",
        jenis_tinggal: "Kontrak",
        alat_transport: "Mobil",
        kodeva: "1234567892",
        nikayah: "3171010101650001",
        namaayah: "Teguh Nugroho",
        keterangan_hidup_ayah: "Hidup",
        tgl_lahir_ayah: "1965-01-01",
        pendidikan_ayah: "S1",
        pekerjaan_ayah: "Wiraswasta",
        penghasilan_ayah: "> Rp. 10.000.000",
        notelp_ayah: "081234567201",
        nik_ibu: "3171010202700002",
        nama_ibu: "Dewi Nugroho",
        keterangan_hidup_ibu: "Hidup",
        tgl_lahir_ibu: "1970-02-02",
        pendidikan_ibu: "S1",
        pekerjaan_ibu: "Wiraswasta",
        penghasilan_ibu: "Rp. 5.000.000 - Rp. 10.000.000",
        notelp_ibu: "081234567202",
        nama_wali: "",
        tgllahirwali: "",
        pendidikan_wali: "",
        pekerjaan_wali: "",
        penghasilan_wali: "",
        notelpwali: "",
        kebutuhan_khusus_mhs: [],
        kebutuhan_khusus_ayah: [],
        kebutuhan_khusus_ibu: [],
        nim_asal_tf: "",
        thnlulus_tf: "",
        jenjang_asal_tf: "",
        perguruan_tinggi_tf: "",
        jurusan_asal_tf: "",
        nama_perguruan_tinggi_asal: "",
        berkas: {
            ktp: "20201003-ktp.jpg",
            kk: "20201003-kk.jpg",
            ijazah: "20201003-ijazah.pdf",
            ijazah_transfer: "",
            transkrip: "",
            skp: ""
        }
    }
};

// Helper untuk mendapatkan biodata berdasarkan NIM
export const getBiodataByNIM = (nim) => {
    return biodataMahasiswa[nim] || null;
};

export default { biodataDropdown, biodataMahasiswa, getBiodataByNIM };
